import axios from 'axios'

const state = {
  isMore: false,
  userRewards: [],
  userReward: null
}

const actions = {
  fetchUserRewards: async ({commit}, params) => {
    if (params.page === 0) {
      commit('SET_USER_REWARDS', [])
      commit('SET_IS_MORE', true)
    }
    const url = 'user-rewards'
    let {data} = await axios.get(url, { params })
    if (!data.error) {
      if (params.page > 0) {
        commit('ADD_USER_REWARDS', data.user_rewards)
      } else {
        commit('SET_USER_REWARDS', data.user_rewards)
      }
    } else {
      commit('SET_IS_MORE', false)
    }
    return data
  },
  fetchUserRewardDetail: async ({commit}, id) => {
    commit('SET_USER_REWARD', null)
    const url = `user-rewards/${id}`
    let {data} = await axios.get(url)
    if (!data.error) {
      commit('SET_USER_REWARD', data.user_reward)
    }
  },
  useReward: async ({commit}, id) => {
    try {
      const url = `user-rewards/${id}/use`
      const { data } = await axios.post(url)
      if (!data.error) {
        const userReward = data.user_reward
        commit('UPDATE_USER_REWARD', { key: 'is_used', value: userReward.is_used })
        commit('UPDATE_USER_REWARD', { key: 'used_at', value: userReward.used_at })
      }
    } catch (e) {
      console.log('check error', e.message)
    }
  }
}

const mutations = {
  SET_IS_MORE: (state, data) => {
    state.isMore = data
  },
  SET_USER_REWARDS: (state, userRewards) => {
    state.userRewards = userRewards
    state.isFetching = false
    state.isMore = true
  },
  ADD_USER_REWARDS: (state, userRewards) => {
    state.isFetching = false
    state.isMore = true
    for (let key in userRewards) {
      state.userRewards.push(userRewards[key])
    }
  },
  SET_USER_REWARD: (state, userReward) => {
    state.userReward = userReward
  },
  UPDATE_USER_REWARD: (state, data) => {
    state.userReward[data.key] = data.value
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.reward.js